export enum Subtype {
    AnniversaryBonusModuleSubtype = "AnniversaryBonusModuleSubtype",
    BirthdayBonusModuleSubtype = "BirthdayBonusModuleSubtype",
    ChecklistAnswerModuleSubtype = "ChecklistAnswerModuleSubtype",
    DropdownAnswerModuleSubtype = "DropdownAnswerModuleSubtype",
    DateModuleSubtype = "DateModuleSubtype",
    EvaluationStarsModuleSubtype = "EvaluationStarsModuleSubtype",
    EvaluationThumbsModuleSubtype = "EvaluationThumbsModuleSubtype",
    MultiPictureUploadModuleSubtype = "MultiPictureUploadModuleSubtype",
    PictureUploadModuleSubtype = "PictureUploadModuleSubtype",
    PresenceQuotaModuleSubtype = "PresenceQuotaModuleSubtype",
    SignatureControlModuleSubtype = "SignatureControlModuleSubtype",
    TextAnswerModuleSubtype = "TextAnswerModuleSubtype",
    WelcomeBonisoftModuleSubtype = "WelcomeBonisoftModuleSubtype",
    SurveyAppointmentModuleSubtype = "SurveyAppointmentModuleSubtype",
    MonthlyTaxFreeBenefitSubtype = "MonthlyTaxFreeBenefitSubtype",
    LinkModuleSubtype = "LinkModuleSubtype",
    Unknown = "Unknown",
};

export interface BaseModuleSubtype {
    subtype: Subtype;
    id: number | null;
    isRequiredForCompletionByEmployee: boolean;
    isRequiredForCompletionByCompanyManagement: boolean;
    order: number;
    name: string | null;
};
